import { render, staticRenderFns } from "./VideoCardMobile.vue?vue&type=template&id=91679568&scoped=true"
import script from "./VideoCardMobile.vue?vue&type=script&lang=js"
export * from "./VideoCardMobile.vue?vue&type=script&lang=js"
import style0 from "./VideoCardMobile.vue?vue&type=style&index=0&id=91679568&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91679568",
  null
  
)

export default component.exports